import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import AppHelmet from '../components/CreateACard/AppHelmet'
import CssBaseline from '@material-ui/core/CssBaseline'
import { MuiThemeProvider } from '@material-ui/core/styles'
import Layout from '../components/SmallBusiness/OrderFlow/Layout/Layout'
import { smbOrderFlowTheme } from '../components/SmallBusiness/OrderFlow/themeStyles'
import { useHistory, useLocation } from 'react-router-dom'
import DeleteCartItemModal from '../components/SmallBusiness/OrderFlow/Components/DeleteCartItemModal'
import {
    setSmbSelectedProduct,
    smbCheckLoginRequest,
    smbSendCobrandForApprovalRequest,
} from '../actions/smbCart'
import isEmpty from 'lodash/isEmpty'
import has from 'lodash/has'
import isEqual from 'lodash/isEqual'
import startCase from 'lodash/startCase'
import isNull from 'lodash/isNull'
import { Typography } from '@material-ui/core'

export const CART_LIMIT_EXCEEDED_ERROR = 'cart_limit_exceeded'

export const CART_SOURCE = 'gcg_smb'

export const CARD_TYPE = {
    PLASTIC: 'plastic',
    DIGITAL: 'digital',
}

export const PAYMENT_METHOD = {
    EXISTING: 'existing_payment_method',
    NEW: 'new_payment_method',
}

export const ORDER_STATUS = {
    COMPLETE: 'complete',
    INCOMPLETE: 'incomplete',
    CANCELLED: 'cancelled',
}

export const DELIVERY_STYLE = {
    TOGETHER: 'bulk_ship',
    INDIVIDUAL: 'individual_ship',
    INDIVIDUAL_EMAIL: 'email',
    SPREADSHEET: 'download',
    PHYSICAL_TOGETHER_INFO_TEXT:
        'The cards will be sent to a single location. All cards will still be affixed to a carrier inside the delivered package. Shipping fee is paid per location.',
    PHYSICAL_INDIVIDUAL_INFO_TEXT:
        'The cards will be sent to individual addresses that you specify per card. Shipping fee is paid per card.',
    VIRTUAL_SPREADSHEET_INFO_IMAGE:
        'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_692,h_130/v1622815155/GCG/smb_assets/gcg_spreadsheet_delivery_example_mkq0cw',
    VIRTUAL_SPREADSHEET_INFO_TEXT: (
        <Typography>
            A downloadable spreadsheet will be provided to you with the Card
            Values, Redemption URLs, and an Access Code (Your purchasing email
            address). You will be responsible for providing the Redemption URL
            and Access Code to your card eGift recipients.{' '}
        </Typography>
    ),
    VIRTUAL_INDIVIDUAL_EMAIL_INFO_IMAGE:
        'https://res.cloudinary.com/gift-card-granny/image/upload/f_auto/w_692,h_130/v1622815155/GCG/smb_assets/gcg_spreadsheet_delivery_example_mkq0cw',
    VIRTUAL_INDIVIDUAL_EMAIL_INFO_TEXT: (
        <Typography>
            Gift Card Granny will send an email to the addresses you specify,
            including a clickable URL link to access their eGift code. They will
            use the email address at which they received the eGift to access
            their eGift code.
        </Typography>
    ),
}

export const DETAILS_ENTRY_TYPE = {
    MANUAL: 'manual',
    SPREADSHEET: 'spreadsheet',
}

export const STEP_SMB_ORDER_FLOW_LANDING = {
    name: 'smb-order-flow-landing',
    route: '/gift-cards-for-business/',
    pageTitle: 'Gift and Reward Cards for Business | GiftCardGranny',
    pageDescription:
        'Visa and Mastercard Reward Cards are the perfect solution to your business needs. Reward and incentivize your customers, employees, and clientele with plastic or virtual gift cards!',
}

export const STEP_SMB_ORDER_FLOW_COBRAND_CARDS = {
    name: 'smb-order-flow-cobrand-cards',
    route: '/gift-cards-for-business/cobrand-cards/',
    pageTitle: 'Cobranded Visa Reward Cards | GiftCardGranny',
    pageDescription:
        'Design a new custom cobranded Visa Reward card, or start an order for a previously approved cobrand!',
}

export const STEP_SMB_ORDER_FLOW_PRODUCT_DETAILS = {
    name: 'smb-order-flow-product-details',
    route: '/gift-cards-for-business/details/',
    pageTitle: 'Choose your Reward Cards | GiftCardGranny',
    pageDescription:
        'Choose and customize your Visa or Mastercard Reward Cards. Pick your desired card type and design and start your order!',
}

export const STEP_SMB_ORDER_FLOW_CUSTOMIZE = {
    name: 'smb-order-flow-customize',
    route: '/gift-cards-for-business/customize/',
    pageTitle: 'Customize your Reward Cards | GiftCardGranny',
    pageDescription:
        'Customize your Visa or Mastercard Reward Cards. Choose how your cards will be delivered.',
}

export const STEP_SMB_ORDER_FLOW_LOGIN = {
    name: 'smb-order-flow-login',
    route: '/gift-cards-for-business/login/',
}

export const STEP_SMB_ORDER_FLOW_REGISTRATION = {
    name: 'smb-order-flow-registration',
    route: '/gift-cards-for-business/registration/',
}

export const STEP_SMB_ORDER_FLOW_PLACE_ORDER = {
    name: 'smb-order-flow-place-order',
    route: '/gift-cards-for-business/place-order/',
    pageTitle: 'Finalize your Reward Cards Order | GiftCardGranny',
    pageDescription:
        'Review and place your order for your Visa or Mastercard Reward Cards.',
}

export const STEP_SMB_ORDER_FLOW_CONFIRMATION = {
    name: 'smb-order-flow-confirmation',
    route: '/gift-cards-for-business/confirmation/',
    pageTitle: 'View your Reward Cards Order | GiftCardGranny',
    pageDescription:
        'View your Gift Card Granny reward card order and print an invoice.',
}

export const STEP_SMB_ORDER_FLOW_ORDER_CANCELLED = {
    name: 'smb-order-flow-order-cancelled',
    route: '/gift-cards-for-business/order-cancelled/',
    pageTitle: 'Gift Cards For Business | Order Cancelled',
    pageDescription: 'Your order has been cancelled',
}

export const smbOrderFlowSteps = [
    STEP_SMB_ORDER_FLOW_LANDING,
    STEP_SMB_ORDER_FLOW_COBRAND_CARDS,
    STEP_SMB_ORDER_FLOW_PRODUCT_DETAILS,
    STEP_SMB_ORDER_FLOW_CUSTOMIZE,
    STEP_SMB_ORDER_FLOW_LOGIN,
    STEP_SMB_ORDER_FLOW_REGISTRATION,
    STEP_SMB_ORDER_FLOW_PLACE_ORDER,
    STEP_SMB_ORDER_FLOW_CONFIRMATION,
    STEP_SMB_ORDER_FLOW_ORDER_CANCELLED,
]

export const getStepByRoute = (route) =>
    smbOrderFlowSteps.find((el) => el.route === route)

export const getCardType = (cardType) => {
    return cardType === CARD_TYPE.PLASTIC
        ? startCase(CARD_TYPE.PLASTIC)
        : startCase(CARD_TYPE.DIGITAL)
}

export const getProductAltText = (cardNetwork, isVirtual) => {
    if (isVirtual) {
        return `${startCase(cardNetwork)} Virtual Reward Card`
    }
    return `${startCase(cardNetwork)} Reward Card`
}

export const renderProductName = (cardNetwork, isVirtual) => {
    if (isVirtual) {
        return (
            <>
                {startCase(cardNetwork)}
                <span className="superscript">&reg;</span> eGift Reward Card
            </>
        )
    }
    return (
        <>
            {startCase(cardNetwork)}
            <span className="superscript">&reg;</span> Reward Card
        </>
    )
}

export const renderDeliveryStyle = (deliveryStyle) => {
    switch (deliveryStyle) {
        case DELIVERY_STYLE.TOGETHER:
            return 'Bulk delivery, ship to one location'
        case DELIVERY_STYLE.INDIVIDUAL:
            return 'Individual delivery, ship to separate locations'
        case DELIVERY_STYLE.SPREADSHEET:
            return 'Downloadable spreadsheet'
        case DELIVERY_STYLE.INDIVIDUAL_EMAIL:
            return 'Individual delivery, email to recipient'
        default:
            return
    }
}

export const getDeliveryGroupItems = (items, deliveryGroups) => {
    return deliveryGroups.map((deliveryGroup) => {
        const deliveryGroupCards = items.filter(
            (item) =>
                (has(item, 'delivery_group_uuid') &&
                    item.delivery_group_uuid === deliveryGroup.uuid) ||
                (has(item, 'deliveryGroupUuid') &&
                    item.deliveryGroupUuid === deliveryGroup.uuid)
        )

        if (has(items[0], 'delivery_group_uuid')) {
            // Getting delivery group items from cart/order response
            return {
                deliveryGroupId: deliveryGroup.uuid,
                deliveryStyle: deliveryGroup.delivery_style,
                minGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (min, item) =>
                        Math.min(min, parseFloat(item.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                maxGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (max, card) =>
                        Math.max(max, parseFloat(card.processing_fee)),
                    parseFloat(deliveryGroupCards[0].processing_fee)
                ),
                priceWithProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                parseFloat(card.price) +
                                parseFloat(card.processing_fee)),
                        0
                    )
                    .toFixed(2),
                product: {
                    cardNetwork:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .card_network,
                    cardType:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .card_type,
                    cardImageUrl: deliveryGroupCards[0].custom_card_image,
                    isVirtual:
                        deliveryGroupCards[0].custom_card_details.wcp_product
                            .virtual_card,
                },
                cards: deliveryGroupCards,
                shippingMethods: deliveryGroup.available_shipping_methods,
                selectedShippingMethod: deliveryGroup.shipping_method,
                bulkShippingName: deliveryGroup.bulk_shipping_name,
                shippingAddress: deliveryGroup.bulk_shipping_address,
            }
        } else if (has(items[0], 'deliveryGroupUuid')) {
            // Getting delivery group items for SMB order details page
            return {
                deliveryGroupId: deliveryGroup.uuid,
                deliveryStyle: deliveryGroup.deliveryStyle,
                minGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (min, item) =>
                        Math.min(min, parseFloat(item.processingFee)),
                    parseFloat(deliveryGroupCards[0].processingFee)
                ),
                maxGroupCardProcessingFee: deliveryGroupCards.reduce(
                    (max, card) =>
                        Math.max(max, parseFloat(card.processingFee)),
                    parseFloat(deliveryGroupCards[0].processingFee)
                ),
                priceWithProcessingFees: deliveryGroupCards
                    .reduce(
                        (acc, card) =>
                            (acc +=
                                parseFloat(card.price) +
                                parseFloat(card.processingFee)),
                        0
                    )
                    .toFixed(2),
                product: {
                    cardNetwork:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .cardNetwork,
                    cardType:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .cardType,
                    cardImageUrl:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .cardImageUrl,
                    isVirtual:
                        deliveryGroupCards[0].customCardDetails.wcpProduct
                            .virtualCard,
                },
                cards: deliveryGroupCards,
                shippingMethods: deliveryGroup.availableShippingMethods,
                selectedShippingMethod: deliveryGroup.shippingMethod,
                bulkShippingName: deliveryGroup.bulkShippingName,
                shippingAddress: deliveryGroup.bulkShippingAddress,
            }
        }
        return null
    })
}

export const getCardDenominationGroups = (cards) => {
    let cardGroups = []
    cards.forEach((card) => {
        const existing = cardGroups.some(
            (item) => parseFloat(item.denomination) === parseFloat(card.balance)
        )

        const cardProcessingFee = has(card, 'processing_fee')
            ? card.processing_fee
            : card.processingFee

        if (!existing) {
            const quantity = cards.filter(
                (c) => parseFloat(c.balance) === parseFloat(card.balance)
            ).length
            const totalFees = parseFloat(cardProcessingFee) * quantity
            cardGroups.push({
                id: card.item_id ?? card.id, // cart items have item_id, order items have id
                denomination: parseFloat(card.balance),
                quantity: quantity,
                fee: parseFloat(cardProcessingFee),
                totalFees: totalFees,
                total:
                    (parseFloat(card.balance) + parseFloat(cardProcessingFee)) *
                    quantity,
            })
        }
    })
    return cardGroups
}

const SMBOrderFlow = (props) => {
    const history = useHistory()
    const location = useLocation()
    const dispatch = useDispatch()
    const selectedProduct = useSelector(
        ({ smbCart }) => smbCart.selectedProduct
    )
    const cartContents = useSelector(({ smbCart }) => smbCart.cartContents)
    const cartItemMarkedForDeletion = useSelector(
        ({ smbCart }) => smbCart.cartItemMarkedForDeletion
    )
    const submittingCobrandForApproval = useSelector(
        (state) => state.smbCart.submittingCobrandForApproval
    )
    const isLoggedIn = useSelector(({ smbCart }) => smbCart.isLoggedIn)
    const { smb_status } = useSelector((state) => state.buyBulk.smbStatus)

    // props
    const { children, baseUrl } = props

    // What step in the flow the user is on.
    const step = getStepByRoute(location.pathname)

    useEffect(() => {
        const stepByRoute = getStepByRoute(location.pathname)
        // Only store user info (name, email, phone number) if on one of these routes
        if (
            isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_PLACE_ORDER) ||
            isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_CONFIRMATION) ||
            isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_ORDER_CANCELLED)
        ) {
            dispatch(smbCheckLoginRequest({ saveUserInfo: true }))
        } else {
            dispatch(smbCheckLoginRequest())
        }
    }, [dispatch, location.pathname])

    useEffect(() => {
        const stepByRoute = getStepByRoute(location.pathname)

        // Check smb status and send back to product selection if rejected
        if (
            !isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_LANDING) &&
            smb_status === 'rejected'
        ) {
            history.replace(STEP_SMB_ORDER_FLOW_LANDING.route)
        }

        // Reset selectedProduct if on the landing page & it's not already reset
        if (
            isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_LANDING) &&
            !isEmpty(selectedProduct)
        ) {
            dispatch(setSmbSelectedProduct(null))
        }

        if (
            (isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_CUSTOMIZE) &&
                isEmpty(selectedProduct)) ||
            (isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_PLACE_ORDER) &&
                (isEmpty(cartContents) ||
                    (has(cartContents, 'cart_items') &&
                        isEmpty(cartContents.cart_items))))
        ) {
            history.push(STEP_SMB_ORDER_FLOW_LANDING.route)
        }

        // Make sure the user logs in or registers for SMB before landing
        // on place order screen or submitting any cobrands for approval
        if (
            isEqual(stepByRoute, STEP_SMB_ORDER_FLOW_PLACE_ORDER) ||
            submittingCobrandForApproval
        ) {
            if (!isLoggedIn) {
                history.push(STEP_SMB_ORDER_FLOW_LOGIN.route)
                return
            }

            if (isLoggedIn && isNull(smb_status)) {
                history.push(STEP_SMB_ORDER_FLOW_REGISTRATION.route)
                return
            }

            submittingCobrandForApproval &&
                dispatch(smbSendCobrandForApprovalRequest())
        }
        // eslint-disable-next-line
    }, [
        location.pathname,
        isLoggedIn,
        smb_status,
        submittingCobrandForApproval,
    ])

    return (
        <>
            <MuiThemeProvider theme={smbOrderFlowTheme}>
                <AppHelmet
                    pageTitle={step.pageTitle}
                    pageDescription={step.pageDescription}
                />
                <CssBaseline />
                <Layout
                    step={step}
                    baseUrl={baseUrl}
                    brandLogoUrl={props.brandLogoUrl}
                    footerContent={props.footerContent}
                >
                    {children}
                    {!isEmpty(cartItemMarkedForDeletion.item) && (
                        <DeleteCartItemModal
                            open={cartItemMarkedForDeletion.openModal}
                            item={cartItemMarkedForDeletion.item}
                            cartId={cartItemMarkedForDeletion.cartId}
                        />
                    )}
                </Layout>
            </MuiThemeProvider>
        </>
    )
}

export default SMBOrderFlow
